onReady(($) => {
    const latestPosts = Array.from(document.querySelectorAll('.latest-posts'))
    for (const latestPost of latestPosts) {
        const ctaButton = latestPost.querySelector('.cta-button')
        ctaButton && ctaButton.addEventListener('click', (event) => submitCtaClickEvent(event, ctaButton, latestPost));
    }
})
